var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.component,{key:_vm.getId,ref:"component",tag:"component",attrs:{"section-info":_vm.sectionInfo,"thumbnail-info":_vm.getThumbnailInfo(),"search-word":_vm.searchWord}})}
var staticRenderFns = []

export { render, staticRenderFns }